/*jshint -W040*/
(function () {
    'use strict';

    angular
        .module('app.region')
        .component('rmapMode', {
            bindings: {
                mode: '<',
                onModeChange: '&'
            },
            templateUrl: 'app/region/dashboard/mode/region.mode.component.html',
            controller: regionModeController,
            controllerAs: 'vm'
        });

    function regionModeController() {
        this.$onChanges = onChanges;
        var vm = this;

        // UI variables
        vm.RegionAreaSwitch = false;
        vm.CreateEditSwitch = false;

        // public methods
        vm.changeMode = changeMode;

        function onChanges(changes) {
            if (changes.mode) {
                vm.RegionAreaSwitch = !vm.mode.isRegion;
                vm.CreateEditSwitch = !vm.mode.isCreate;
            }
        }
        
        function changeMode() {
            vm.mode = {
                isRegion: !vm.RegionAreaSwitch,
                isArea: vm.RegionAreaSwitch,
                isCreate: !vm.CreateEditSwitch,
                isEdit: vm.CreateEditSwitch
            };
            vm.onModeChange({ mode: vm.mode });
        }
    }
})();
